"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicGiftcloudContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.publicGiftcloudContract = c.router({
    processRewardEventNotification: {
        method: 'POST',
        path: '/process-reward-event-notification',
        body: models_1.ZGiftcloudRewardEventNotification,
        responses: {
            200: utils_1.successSchema,
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Webhook for receiving reward event notifications from Giftcloud',
    },
});
//# sourceMappingURL=giftcloud.public.contract.js.map